<template>
  <div class="account-title-balance-header">
    <div>{{ params.displayName }}</div>
    <div class="unit">
      <span>{{ $t('CargoMsg.Cargo_AmountNumber') }}</span>
      <span>{{ $t('CargoMsg.Cargo_OriginalCurrency') }}</span>
      <span>{{ $t('CargoMsg.Cargo_LocalCurrency') }}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'AccountTitleBalanceHeader',
  created() {
    console.log('this.params')
    console.log(this.params)
  }
})
</script>

<style lang="scss">
.account-title-balance-header{
  .unit{
    display: flex;
    justify-content: space-between;
    span{
      flex: 1;
      border-right: 1px solid #e6e6e6;
      &.blue{
        border-color:#a7d9f5;
      }
      &.pink{
        border-color:#eebbbb;
      }
      &:nth-last-child(1){
        border:none
      }
    }
  }
}

</style>
